<template>
  
  <search-picker 
    ref="searchPicker"
    path="animals" 
    attributes="id,name,sex,raceId,ownerId"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderLabel="renderLabel"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"

  export default {

    name: "AnimalPicker",

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },      
    },
    
    components: {
      SearchPicker,
    },  

    methods: {

      renderTitle(animal) {

        let title = ""
        let icon = animal.sex == "male" ? "mars blue icon" : "venus pink icon"

        if (animal.sex == "undefined")
          icon = "question circle grey icon"

        title =  `<div><i class="${icon}"></i> ${animal.name} `
        title += `<div class="ui tiny label m-l-10">${animal.race.name} `
        title += `<div class="detail">Espécie ${animal.race.species.name}</div></div></div>`

        return title
      },

      renderLabel(animal) {
        return animal.name
      },

      renderDescription(animal) {
        return `<div class="m-t-10"><i class="user circle violet icon"></i> ${animal.owner.name}</div>`
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(animal) {
        this.$emit("onPick", animal)
      },

      setSelected(animal) {
        this.$refs.searchPicker.setSelected(animal)
      },
    },
  }

</script>